import { motion } from "framer-motion";
import { Plane, Ship, Home, Bike, Globe, FileCheck, Timer, Warehouse, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { SERVICES } from "@/lib/site-data";

const ICONS = {
  air: Plane,
  sea: Ship,
  doortodoor: Home,
  local: Bike,
  overseas: Globe,
  customs: FileCheck,
  sameday: Timer,
  warehouse: Warehouse,
};

export default function Services() {
  return (
    <section id="services" className="relative py-24 sm:py-32 bg-[#F5F5F7] border-y border-black/5">
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8">
        <Reveal>
          <div className="mb-4 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.22em] text-[#E31B23]">
            <span className="h-px w-8 bg-[#E31B23]" /> What we do
          </div>
          <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
            <h2 className="max-w-2xl font-display text-4xl font-extrabold leading-tight text-[#1F1F1F] sm:text-5xl">
              Every service you need to move goods.
            </h2>
            <p className="max-w-sm text-[#4b5563]">
              One partner for courier, freight, fulfilment and customs — from a single parcel to a
              full supply chain.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.key];
            return (
              <Reveal key={s.key} delay={(i % 4) * 0.06}>
                <motion.a
                  href="#tools"
                  data-testid={`service-${s.key}`}
                  whileHover={{ y: -6 }}
                  transition={{ type: "spring", stiffness: 300, damping: 24 }}
                  className="group block h-full rounded-3xl bg-white border border-black/5 p-7 shadow-[0_10px_30px_-20px_rgba(17,24,39,0.3)] hover:border-[#5A189A]/25 hover:shadow-[0_24px_50px_-24px_rgba(61,10,110,0.4)]"
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#5A189A]/10 group-hover:bg-[#E31B23] transition-colors duration-300">
                    <Icon size={20} className="text-[#5A189A] group-hover:text-white transition-colors duration-300" />
                  </span>
                  <h3 className="mt-6 font-display text-xl font-bold text-[#1F1F1F] flex items-center gap-2">
                    {s.title}
                    <ArrowUpRight size={17} className="text-[#E31B23] opacity-0 -translate-x-1 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0" />
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-[#4b5563]">{s.desc}</p>
                </motion.a>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
